import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { ENV_TOKEN } from '../app.config'

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  private readonly apiUrl = inject(ENV_TOKEN).api.url
  private readonly http = inject(HttpClient)

  evictCache$(secret: string) {
    return this.http.post(`${this.apiUrl}/caching/evict/all`, null, {
      params: {
        secret,
      },
    })
  }
}
